import axios from 'axios'


/**
 *
 * @status no delete
 * @class AddressService
 */
class AddressService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl
  }

  /**
  * @author Lucia Alvarado
  * @description Handle event to create a new address in A3Cloud
  * @date 20-07-2020
  * @param {String} token
  * @param {Object} address
  * @returns {Object}
  * @memberof AddressService
  */
  async createAddress(token, address) {
    let { street, colony, township, state, zipCode, userAddress, email } = address

    let response = await axios.post(`${this.apiUrl}/address`, {
      street,
      internalNumber: '1',
      externalNumber: '1',
      colony,
      township,
      state,
      country: 'MX',
      zipCode,
      userAddress,
      email
    }, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data
  }

  /**
* @author Alan Aguilar
* @description Handle event to update an existing address in A3Cloud
* @date 05-10-2020
* @status no delete
* @param {String} street
* @param {String} internalNumber
* @param {String} externalNumber
* @param {String} colony
* @param {String} township
* @param {String} state
* @param {String} country
* @param {String} zipCode
* @param {String} email
* @param {String} token
* @returns {Object}
* @memberof AddressService
*/
  async createAddressInvited(street, internalNumber, externalNumber, colony, township, state, country, zipCode, email, token, rfc) {
    let response = await axios.post(`${this.apiUrl}/address-passthrough`, {
      street,
      internalNumber,
      externalNumber,
      colony,
      township,
      state,
      country,
      zipCode,
      email,
      rfc
    }, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data
  }

  /**
  * @author Alan Aguilar
  * @description Handle event to update an existing address in A3Cloud
  * @date 05-10-2020
  * @status no delete
  * @param {Number} id
  * @param {String} street
  * @param {String} internalNumber
  * @param {String} externalNumber
  * @param {String} colony
  * @param {String} township
  * @param {String} state
  * @param {String} country
  * @param {String} zipCode
  * @param {String} token
  * @returns {Object}
  * @memberof AddressService
  */
  async updateAddress(id, street, internalNumber, externalNumber, colony, township, state, country, zipCode, token) {
    let response = await axios.put(`${this.apiUrl}/address-passthrough`, {
      id,
      street,
      internalNumber,
      externalNumber,
      colony,
      township,
      state,
      country,
      zipCode
    }, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data
  }
}

export { AddressService as default }
